import { render, staticRenderFns } from "./authurl.vue?vue&type=template&id=1380b8a5&"
import script from "./authurl.vue?vue&type=script&lang=js&"
export * from "./authurl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports